import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Fetcher } from "../../components/Fetcher";
import { getFeatureToggle } from "../../services/api/featureToggles.api";
import { FeatureToggleDetails } from "../../components/FeatureToggles/FeatureToggleDetails";
import { FeatureToggleEdit } from "../../components/FeatureToggles/FeatureToggleEdit";
import { hasPowFeature, POW_FEATURES } from "../../services/powFeatures.service";
import { useForceUpdate } from "../../utils/hooks";

interface FeatureToggleDetailPageProps {
	// feature toggle id to fetch details
	featureToggleId: string;
	// product id
	productId: string;
}

const useStyles = makeStyles((theme) => ({
	wrapper: {
		marginBottom: theme.spacing(4),
		maxWidth: 1024,
	},
	title: {
		marginBottom: theme.spacing(4),
	},
}));

/**
 * Page to display feature toggle details and allow configuration editing
 * @param props
 */
export const FeatureToggleDetailsPage = (props: FeatureToggleDetailPageProps) => {
	const classes = useStyles();
	const forceUpdate = useForceUpdate();

	return (
		<div className={classes.wrapper} data-testid="feature-toggles-details-page">
			<Typography className={classes.title} variant="h4">
				Feature Toggle Details
			</Typography>
			<Fetcher action={getFeatureToggle(props.productId, props.featureToggleId)}>
				{({ data }) =>
					hasPowFeature(POW_FEATURES.paFeatures_Admin) ? (
						<FeatureToggleEdit featureToggle={data} productId={props.productId} onSuccess={forceUpdate} />
					) : (
						<FeatureToggleDetails featureToggle={data} />
					)
				}
			</Fetcher>
		</div>
	);
};
